/* eslint key-spacing:0 */
/* eslint no-multi-spaces:0 */
const greenLight = '#9cfff8';
const green = '#20D6C9';
const green2 = '#1dc9bc';
const green3 = '#7fc613';
const green4 = '#4EC35D';
const aqua = '#337ab7';
const blue = '#4169E1';
const blue2 = '#2B3446';
const blue3 = '#2F51B7';
const blue4 = '#2351dc';
const blue5 = '#423bae';
const redLight = '#FFECE2';
const red = '#FF4337';
const red2 = '#EF4100';
// red2 darkened to pass WCAG AA (about 5.5:1) as small text on white
const red2Text = '#C23400';
const extraLightGrey = '#EEE';
const lightGrey = '#F9F9FC';
const grey = 'grey';
const grey2 = '#DDD';
const grey3 = '#C9CDD7';
const grey4 = '#EDEDED';
const grey5 = '#CECED0';
const grey6 = '#808080';
const grey7 = '#666';
const grey8 = '#909090';
const grey9 = '#CCC';
const grey10 = '#F0F0F0';
const grey11 = '#a4a4a4';
const grey12 = '#d7d7d3';
const grey13 = '#e5e4da';
const black = '#000000';
const white = '#FFFFFF';
const snow = '#EEE9EE';
const lightBlack = '#333333';
const extraLightBlack = '#626262';
const yellow = '#FFC000';
const beige = '#F6F5F0';
const shadow = '#999';
const faceBookBlue = '#3c599b';
const linkedinBlue = '#0d638f';
const google = '#af3c31';

export const clr = {
  answerBorder: grey5,
  backgroundError: redLight,
  balance: grey3,
  base: lightBlack,
  bottomValidationError: red2,
  bottomValidationErrorText: red2Text,
  boxShadow: shadow,
  closeSurveyHover: blue2,
  dark: black,
  deleteIcon: blue3,
  dimBase: grey2,
  dimBase10: grey13,
  dimBase2: grey5,
  dimBase3: grey7,
  dimBase4: grey8,
  dimBase5: grey9,
  dimBase6: grey4,
  dimBase7: grey10,
  dimBase8: grey11,
  dimBase9: grey12,
  disable: blue5,
  dropDownArrow: blue3,
  dropDownBorder: grey4,
  extraLightBase: white,
  facebook: faceBookBlue,
  focus: blue4,
  footer: extraLightGrey,
  footerText: lightBlack,
  google,
  green4,
  highlight: blue,
  label: grey6,
  lightBase: extraLightGrey,
  lightBase2: lightGrey,
  lightDark: extraLightBlack,
  link: aqua,
  linkedIn: linkedinBlue,
  mediumBase: snow,
  negative: white,
  offWhite: beige,
  primary: green,
  primaryDark: green2,
  primaryLight: greenLight,
  select: grey7,
  star: grey,
  starActive: yellow,
  success: green3,
  validationError: red,
};

export const removeSpinner = {
  '::-webkit-inner-spin-button, ::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
};

const spacingFactor = 6;
export const spacing = {
  space0: `${spacingFactor / 2}px`, // 3
  space1: `${spacingFactor}px`, // 6
  space14: `${spacingFactor * 14}px`, // 84
  space2: `${spacingFactor * 2}px`, // 12
  space3: `${spacingFactor * 3}px`, // 18
  space4: `${spacingFactor * 4}px`, // 24
  space5: `${spacingFactor * 5}px`, // 30
  space6: `${spacingFactor * 6}px`, // 36
  space8: `${spacingFactor * 7}px`, // 42
  space9: `${spacingFactor * 8}px`, // 48
};

export const breakpoints = {
  x: {
    full: '',
    narrow: '31.25rem',
    wide: '50.00rem',
  },
};

export const smartPhoneScreenSizeMax = 767;
export const tabletScreenSizeMax = 991;
export const desktopScreenSize = 769;
const mos = `@media only screen`;

export const screenSize = {
  desktopOnly: `${mos} and (min-width: ${tabletScreenSizeMax + 1}px)`,
  desktopOrTablet: `${mos} and (min-width: ${smartPhoneScreenSizeMax + 1}px)`,
  smartphone: `${mos} and (max-width: ${smartPhoneScreenSizeMax}px)`,
  tablet: `${mos} and (min-width: ${smartPhoneScreenSizeMax + 1}px) and (max-width: ${tabletScreenSizeMax}px)`,
};
